// extracted by mini-css-extract-plugin
export var animationContainer = "_iv-0";
export var asteriskIcon = "_iv-8";
export var conversationLeftSection = "_iv-4";
export var conversationListItem = "_iv-3";
export var conversationMiddleSection = "_iv-5";
export var conversationRightSection = "_iv-6";
export var detailsContent = "_iv-1";
export var listContainer = "_iv-7";
export var modalContent = "_iv-2";